module.exports = __webpack_public_path__ + "static/assets/78ffb84aece1bdea8c785f86a0df081f.png";